/**
 * 入场爱心炸开以后的那段话（星海设置里写，SpaceDto.introText）：怎么断行。
 * 字画在画布上（它就是之后化成星尘的那张图，见 ui.ts 的 mountIntroWords），所以断行自己算，不靠网页排版。
 */

/** 不能放在行首的标点：遇到了就挂在上一行末尾，宁可稍微超出一点 */
const NO_LINE_START = '，。、；：？！）」』》〉】”’…·,.;:?!)]}%';

/**
 * 按宽度断行：先按换行符分段，再一个字一个字往行里放（拉丁字母连着的单词不拆开）。
 * width(s) 是这段字画出来有多宽（含字距）；maxWidth 以内放不下就换行。
 */
export function wrapLines(text: string, width: (s: string) => number, maxWidth: number): string[] {
  const out: string[] = [];
  for (const para of text.split('\n')) {
    // 单词（连着的拉丁字母、数字）当成一个整体，其余一个字一段
    const pieces = para.match(/[A-Za-z0-9'’\-]+|\s+|./gu) ?? [];
    let line = '';
    for (const piece of pieces) {
      const next = line + piece;
      if (!line || width(next) <= maxWidth || (piece.length === 1 && NO_LINE_START.includes(piece))) {
        line = next;
        continue;
      }
      out.push(line.trimEnd());
      line = /^\s+$/.test(piece) ? '' : piece;
    }
    out.push(line.trimEnd());
  }
  return out;
}

/** 没写那段话时的默认文案 */
export function defaultWords(days: number, stars: number): string {
  const d = Math.max(1, days).toLocaleString('zh-CN');
  return `在一起的第 ${d} 天\n${stars > 0 ? `已经点亮了 ${stars.toLocaleString('zh-CN')} 颗星` : '第一颗星，等你们来点亮'}`;
}
